module.exports = __webpack_public_path__ + "img/services-gift-side.9efd30fb.png";